import React, {useCallback, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDropzone} from 'react-dropzone';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

//DS
import ListaArchivos from './ListaArchivos';
import {bytesTransformar, generarNombreArchivo, generarMetadata} from './helpFunc';

const useStyles = makeStyles()(theme => ({
   root: {
      height: 'auto'
   },
   contenedorDZ: {
      backgroundColor: theme.palette.primary.light,
      height: '10vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: 'dashed',
      borderColor: theme.palette.secondary.light
   },
   nested: {
      paddingLeft: theme.spacing(4)
   },
   hidden: {
      display: 'none'
   },
   listaAceptados: {
      /*
      display: 'flex',
      padding: 0,
      */
   },
   itemAceptados: {}
}));

function RejectedFiles(props) {
   const { classes } = useStyles();
   const {fileRejections} = props;
   return (
      <List dense>
         <ListItem>
            <Typography variant="body1" color="error">
               No se pudieron agregar los siguientes archivos:
            </Typography>
         </ListItem>
         {fileRejections.map(({file, errors}) => (
            <div key={file.path}>
               <ListItem>
                  <Typography variant="body1" color="error">
                     {generarNombreArchivo(file)}
                  </Typography>
               </ListItem>
               <List component="div" disablePadding dense>
                  {errors.map(e => {
                     return (
                        <ListItem key={e.code} className={classes.nested}>
                           <Typography variant="caption" color="error">
                              - {e.message}
                           </Typography>
                        </ListItem>
                     );
                  })}
               </List>
            </div>
         ))}
      </List>
   );
}

function AdjuntarArchivos(props) {
   const {maxSize, metadataLista, archivosAceptados, onChangeArchivosAceptados} = props;
   const { classes } = useStyles();
   const [metadata, setMetadata] = useState('');
   useEffect(() => {
      if (metadataLista === undefined || metadataLista === null || metadataLista.length === 0) {
         setMetadata('');
      } else {
         generarMetadata(metadataLista).then(metaGenerado => {
            setMetadata(metaGenerado);
         });
      }
   }, [metadataLista]);

   const onDrop = useCallback(
      acceptedFiles => {
         const nuevosArchivos = acceptedFiles.map(item => {
            return {file: item, metadata: metadata};
         });
         if (typeof onChangeArchivosAceptados === 'function') {
            onChangeArchivosAceptados([...archivosAceptados, ...nuevosArchivos]);
         }
      },
      [metadata, archivosAceptados]
   );

   const {fileRejections, getRootProps, getInputProps, isDragActive} = useDropzone({
      onDrop,
      maxSize
   });

   return (
      <div className={classes.root}>
         <div {...getRootProps({className: classes.contenedorDZ})}>
            <input {...getInputProps()} />
            <Typography display="block" align="center">
               Arrastre y suelte archivos aquí, o haga clic para seleccionar archivos.{' '}
               {maxSize && `Tamaño maximo:${bytesTransformar(maxSize)} MBs`}
            </Typography>
         </div>
         {archivosAceptados.length > 0 && (
            <ListaArchivos
               modo="subir"
               metadata={metadata}
               archivos={archivosAceptados}
               setArchivos={onChangeArchivosAceptados}
            />
         )}
         {fileRejections.length > 0 && <RejectedFiles fileRejections={fileRejections} />}
      </div>
   );
}

AdjuntarArchivos.propTypes = {
   maxSize: PropTypes.number,
   metadataLista: PropTypes.array,
   archivosAceptados: PropTypes.arrayOf(
      PropTypes.shape({file: PropTypes.object, metadata: PropTypes.string})
   ),
   onChangeArchivosAceptados: PropTypes.func
};

AdjuntarArchivos.defaultProps = {};

export default AdjuntarArchivos;
